export default __webpack_public_path__ + "static/media/undraw_news.b41df2c9.svg";